import { createIcon } from '@chakra-ui/react';

export const CloseX = createIcon({
  displayName: 'CloseX',
  viewBox: '0 0 14 14',
  path: (
    <path
      id="X_Close_-_S-2"
      data-name="X Close - S"
      d="M6.78,6l4.56-4.56a.56.56,0,0,0,0-.78.56.56,0,0,0-.78,0L6,5.22,1.44.66a.56.56,0,0,0-.78,0,.56.56,0,0,0,0,.78L5.22,6,.66,10.56a.56.56,0,0,0,0,.78.56.56,0,0,0,.78,0L6,6.78l4.56,4.56a.552.552,0,1,0,.78-.78Z"
      transform="translate(0.5 1)"
      fill="currentColor"
    />
  ),
});
